(function ($) {
  $(document).ready(function () {
    const cart = $('.woocommerce-cart');
    const checkout = $('.woocommerce-checkout');
    const deliveryPage = $('.woocommerce-delivery-data-page');
    const paymentPage = $('.woocommerce-payment-data-page');

    // Disable minicart toggle on cart and checkout
    if (
      cart.length > 0 ||
      checkout.length > 0 ||
      deliveryPage.length > 0 ||
      paymentPage.length > 0
    ) {
      $(
        '.elementor-menu-cart__toggle_wrapper, #elementor-menu-cart__toggle_button'
      ).off();

      $(
        '.elementor-menu-cart__toggle_wrapper, #elementor-menu-cart__toggle_button'
      ).on('click', function (event) {
        event.stopImmediatePropagation();
      });
    }
  });
})(jQuery);
